export default [
	'blockCard',
	'paragraph_with_no_marks',
	'paragraph_with_alignment',
	'paragraph_with_indentation',
	'mediaSingle_caption',
	'mediaSingle_full',
	'codeBlock_with_no_marks',
	'taskList',
	'bulletList',
	'orderedList',
	'heading_with_no_marks',
	'heading_with_alignment',
	'heading_with_indentation',
	'mediaGroup',
	'decisionList',
	'rule',
	'panel',
	'blockquote',
	'extension_with_marks',
	'embedCard',
	'table',
	'expand_with_no_mark',
	'bodiedExtension_with_marks',
];
